import request from './request'

export function managerlistConfig(params) {
  console.log(params);
  return request({
    method: 'get',
    url: "/manager/listConfig",
    params,
  })
}
// 分页显示所有模块
export function categorylistAll(params) {
  console.log(params);
  return request({
    method: 'get',
    url: "/category/listAll",
    params,
  })
}
// 显示考试动态
export function contentlistAllNews(params) {
  console.log(params);
  return request({
    method: 'get',
    url: "/content/listAllNews",
    params,
  })
}
// 显示通知公告
export function contentlistAllNotices(params) {
  console.log(params);
  return request({
    method: 'get',
    url: "/content/listAllNotices",
    params,
  })
}
// /显示文章详情
export function contentdetail(params) {
  console.log(params);
  return request({
    method: 'get',
    url: "/content/listDetail",
    params,
  })
}
export function bannerlistDetail(params) {
  console.log(params);
  return request({
    method: 'get',
    url: "/banner/listDetail",
    params,
  })
}
// 查看指定模块的子模块
export function categorylistChildren(params) {
  console.log(params);
  return request({
    method: 'get',
    url: "/category/listChildren",
    params,
  })
}

// 分页显示模块下文章
export function contenlist(params) {
  console.log(params);
  return request({
    method: 'get',
    url: "/content/list",
    params,
  })
}
// 搜索结果分页 
export function contentlistResult(params) {
  console.log(params);
  return request({
    method: 'get',
    url: "/content/listResult",
    params,
  })
}
// 显示排名前6的热搜词
export function hotWordslistTop(params) {
  console.log(params);
  return request({
    method: 'get',
    url: "/hotWords/listTop",
    params,
  })
}
// 显示最近创建的5个搜索词
export function hotWordslistRecent(params) {
  console.log(params);
  return request({
    method: 'get',
    url: "/hotWords/listRecent",
    params,
  })
}


export function restapi(params) {
  console.log(params);
  return request({
    method: 'get',
    url: "https://restapi.amap.com/v3/weather/weatherInfo?city=330200&key=64aa75a92c14764be2ec255e8b672ebe",
    params,
  })
}